import React, { FC, useEffect } from "react";
import { YhBox } from "@/components/YhBox";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { Description } from "@/components/YhBox/Description";
import { Button, message } from "antd";
import { useDiscernModel } from "../../discernModel";
import { discernService } from "../../discernService";
import { jsFormSender } from "@/utils/jsFormSender";
import { globalPrompt } from "@/components/message";

export const TopButs: FC<RouterParamType> = ({ id, mode }) => {
	const { setLabelResultDrawer, setLabelInfoDrawer, discernOne, downloadFile } = useDiscernModel();
	const { addNav, selectedNavId, replaceNav } = useNavModel(({ selectedNavId }) => [selectedNavId]);

	const onCancel = (id: string) => {
		globalPrompt("modal", {
			title: "确认删除？",
			text: "",
			onOk: () => discernService.distinguishCancel(id).then(res => {
				replaceNav(selectedNavId, "3-2")
				message.success("作废成功");
			})
		});
	}

	const orderStatu: IDescription[] = [
		{
			label: "标题",
			value: discernOne?.title ?? "",
			color: DescriptionColorEnum.green,
			status: true
		},
		{
			label: "状态",
			value: `${+(discernOne?.seeStatus ?? 0) ? "已标注" : "未标注"}`,
			color: DescriptionColorEnum.green,
			status: true
		},
		{
			label: "发布时间",
			value: discernOne?.pubTime ?? "",
			color: DescriptionColorEnum.black,
			status: true
		},
		{
			label: "首次查看时间",
			value: discernOne?.seeTime ?? "",
			color: DescriptionColorEnum.black,
			status: true
		},
		{
			label: "信息来源",
			value: discernOne?.sourceFrom ?? "",
			color: DescriptionColorEnum.black,
			status: true
		},
		{
			label: "关键词",
			value: discernOne?.keywords ?? "",
			color: DescriptionColorEnum.black,
			status: true
		},
	]

	const handleLabelResult = async () => {
		let { retData } = await discernService.labelResultOne(id);
		setLabelInfoDrawer(false);
		if (retData) {
			setLabelResultDrawer({ visible: true, mode: "edit", record: retData });
		} else {
			setLabelResultDrawer({ visible: true, mode: "add" });
		}
	};



	const action = <>
		<Button
			className="mr-5"
			type="link"
			shape="round"
			onClick={() => { setLabelResultDrawer({ visible: false, mode: "add" }); setLabelInfoDrawer(true) }}
		>标注</Button>
		<Button
			className="mr-5"
			type="link"
			shape="round"
			onClick={handleLabelResult}
		>开标结果标注</Button>
		<Button
			className="mr-5"
			type="link"
			shape="round"
			onClick={() => replaceNav(selectedNavId, "3-2")}
		>返回</Button>
		<Button
			className="mr-5"
			type="link"
			shape="round"
			onClick={() => downloadFile(discernOne?.id)}
		>下载</Button>
		<Button
			className="mr-5"
			type="link"
			shape="round"
			onClick={() => onCancel(id)}
		>删除</Button>
	</>

	const open = () => {
		// url && window.open(url, '_blank');
		if (discernOne?.detailLink) {
			if (discernOne.sourceFrom === "中国交建") {
				jsFormSender(discernOne?.detailLink, {
					'condition_aid': '',
					'condition_pid': '',
					'condition_supCode': "",
					'pk_announce': discernOne?.oid ?? '',
					'type': '',
					'setp': ''
				}, 'post', '_blank');
				return;
			}
			jsFormSender(discernOne?.detailLink, {}, 'get', '_blank');
		}
	}

	return (
		<YhBox
			title={<>
				{orderStatu.map((item, index) => <Description key={index} {...item} />)}
				<span className="list-header-content-statu-item" style={{ display: "block" }}>
					原文链接：<span className="list-header-content-statu statu-blue" onClick={() => open()} style={{ cursor: "pointer", textDecoration: "underline" }}>
						{discernOne?.sourceFrom === "中国石油招标投标网" ? "https://www.cnpcbidding.com" : discernOne?.detailLink ?? ""}
					</span>
				</span>
			</>}
			style={{ paddingBottom: 0, marginBottom: "15px" }}
			action={action}
		/>
	)
}